// extracted by mini-css-extract-plugin
export default {"imageWrapper":"XR-z","hovered":"YR-z","hoverImage":"ZR-z","mainImage":"_R-z","imageNoBackground":"aS-z","fullSizeImage":"bS-z"};